import { RevivalProductName, RevivalStatus, RevivalTypeRequest } from 'models/revival'

export const REVIVAL_STATUS_TEXT: Record<RevivalStatus, string> = {
  [RevivalStatus.in_process]: 'Под наблюдением',
  [RevivalStatus.success]: 'Успешно',
  [RevivalStatus.failed]: 'Неуспешно',
}

export const REVIVAL_TYPE_REQUEST_TEXT: Record<RevivalTypeRequest, string> = {
  [RevivalTypeRequest.ep]: 'ИП',
  [RevivalTypeRequest.le]: 'ЮР ЛИЦО',
}

export const REVIVAL_PRODUCT_NAME_TEXT: Record<RevivalProductName, string> = {
  [RevivalProductName.mKassa]: 'МКасса',
  [RevivalProductName.mPlus]: 'М+',
}

export const REVIVAL_PRODUCT_NAME_OPTIONS = Object.entries(REVIVAL_PRODUCT_NAME_TEXT).map(([value, title]) => ({
  title,
  value,
}))
